import { Box, Button, Flex, Input, Text } from '@modusign/design-system';

import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';

interface CompanyNameStepMobileProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function CompanyNameStepMobile({ nextStep, survey, setSurvey }: CompanyNameStepMobileProps) {
  const isFormValid = !!survey.companyName;

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        입력하신 정보에 맞게 모두싸인을 설정해 드릴게요.
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">회사명</Text>{' '}
          <Text color="textNeutralLight">(추후 수정 가능)</Text>
        </Box>
        <Box mt={3}>
          <Input
            autoFocus
            height="44px"
            maxLength={30}
            minLength={1}
            placeholder="1자 이상 30자 이내"
            required
            value={survey.companyName}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, companyName: currentTarget.value }))
            }
          />
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default CompanyNameStepMobile;
